// Шаблоны сообщений мессенджера (выделено из reference.api.ts планом 108, Ф4).
import { api } from '@/lib/api';

import { defined, type ListParams } from './_shared.js';

// --- Шаблоны сообщений мессенджера (М6 батча №20) ---------------------------
// Привязка к локациям — мультивыбор; ПУСТОЙ список = шаблон для всей школы
// (та же семантика, что в галерее и новостях).

export interface MessageTemplateItem {
  id: string;
  title: string;
  body: string;
  sortOrder: number;
  isArchived: boolean;
  branchIds: string[];
  /** Картинка шаблона (messenger_media, план 103); null — только текст. */
  mediaId?: string | null;
}

export interface CreateMessageTemplateBody {
  title: string;
  body: string;
  sortOrder?: number;
  branchIds?: string[];
  /** Картинка шаблона (messenger_media, план 103); null — снять. */
  mediaId?: string | null;
}

export interface UpdateMessageTemplateBody {
  title?: string;
  body?: string;
  sortOrder?: number;
  isArchived?: boolean;
  branchIds?: string[];
  /** Картинка шаблона (messenger_media, план 103); null — снять. */
  mediaId?: string | null;
}

export function listMessageTemplates(
  params: ListParams & { branchId?: string } = {},
): Promise<{ items: MessageTemplateItem[] }> {
  const sp = new URLSearchParams();
  if (params.includeArchived) sp.set('include_archived', 'true');
  if (params.branchId) sp.set('branch_id', params.branchId);
  const qs = sp.toString();
  return api.get<{ items: MessageTemplateItem[] }>(`/message-templates${qs ? `?${qs}` : ''}`);
}

export function createMessageTemplate(
  body: CreateMessageTemplateBody,
): Promise<{ template: MessageTemplateItem }> {
  return api.post('/message-templates', {
    title: body.title,
    body: body.body,
    ...(body.sortOrder !== undefined ? { sort_order: body.sortOrder } : {}),
    ...(body.branchIds !== undefined ? { branch_ids: body.branchIds } : {}),
    ...(body.mediaId !== undefined ? { media_id: body.mediaId } : {}),
  });
}

export function updateMessageTemplate(
  id: string,
  body: UpdateMessageTemplateBody,
): Promise<{ template: MessageTemplateItem }> {
  return api.patch(
    `/message-templates/${id}`,
    defined({
      title: body.title,
      body: body.body,
      sort_order: body.sortOrder,
      is_archived: body.isArchived,
      branch_ids: body.branchIds,
      media_id: body.mediaId,
    }),
  );
}

export function archiveMessageTemplate(id: string): Promise<void> {
  return api.delete<void>(`/message-templates/${id}`);
}
